(() => {
  if (window.__collectionNativeFiltersMobileBound) return;
  window.__collectionNativeFiltersMobileBound = true;

  const mobileQuery = window.matchMedia("(max-width: 767px)");

  const getOverlay = (drawer) => {
    if (!drawer || !drawer.parentElement) return null;
    return drawer.parentElement.querySelector(".collection-native-filters-overlay");
  };

  const getOpenButtons = (drawer) => {
    if (!drawer || !drawer.id) return [];
    return document.querySelectorAll(
      `[data-native-filter-open][aria-controls="${drawer.id}"]`
    );
  };

  const setOpenState = (drawer, isOpen) => {
    const overlay = getOverlay(drawer);

    drawer.classList.toggle("is-open", isOpen);
    if (overlay) overlay.classList.toggle("is-visible", isOpen);

    getOpenButtons(drawer).forEach((button) => {
      button.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    document.body.classList.toggle("collection-native-filter-lock", isOpen);

    if (isOpen) {
      window.setTimeout(() => {
        const closeButton = drawer.querySelector("[data-native-filter-close]");
        if (closeButton) closeButton.focus();
      }, 80);
    }
  };

  const openDrawer = (drawer) => {
    if (!drawer || !mobileQuery.matches) return;
    setOpenState(drawer, true);
  };

  const closeDrawer = (drawer) => {
    if (!drawer) return;
    setOpenState(drawer, false);
  };

  const closeAllDrawers = () => {
    document
      .querySelectorAll("[data-native-filter-drawer].is-open")
      .forEach((drawer) => closeDrawer(drawer));
  };

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;

    const openButton = event.target.closest("[data-native-filter-open]");
    if (openButton) {
      const drawerId = openButton.getAttribute("aria-controls");
      openDrawer(document.getElementById(drawerId));
      event.preventDefault();
      return;
    }

    if (event.target.closest("[data-native-filter-close]")) {
      closeAllDrawers();
      event.preventDefault();
      return;
    }

    const applyButton = event.target.closest(
      "[data-native-filter-drawer] .filter--button[data-type='apply']"
    );
    if (applyButton) closeAllDrawers();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeAllDrawers();
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", (event) => {
      if (!event.matches) closeAllDrawers();
    });
  } else {
    mobileQuery.addListener((event) => {
      if (!event.matches) closeAllDrawers();
    });
  }
})();

// Collections start filtered by "Em estoque" (see `stock_default` in main-collection.liquid)
(() => {
  if (window.__collectionStockDefaultBound) return;
  window.__collectionStockDefaultBound = true;

  const param = "filter.v.availability";
  const in_stock_selector = `input[name="${param}"][value="1"]`;
  const optout_key = `collection-stock-optout:${location.pathname}`;

  // remember when the shopper removes the availability filter, so reloads,
  // pagination and back navigation on this collection respect that choice
  window.addEventListener("theme:navigation:reloaded", () => {
    try {
      if (new URLSearchParams(location.search).has(param)) {
        sessionStorage.removeItem(optout_key);
      } else {
        sessionStorage.setItem(optout_key, "1");
      }
    } catch (e) {}
  });

  const wrapper = document.querySelector('[data-body-wrapper][data-stock-default="pending"]');
  if (!wrapper) return;

  const applyStockDefault = () => {
    const navigations = [...document.querySelectorAll("navigation-element")].filter(
      (navigation) =>
        typeof navigation.getAjaxUrl === "function" &&
        navigation.filter_form &&
        navigation.filter_form.querySelector(in_stock_selector)
    );

    if (!navigations.length) {
      wrapper.removeAttribute("data-stock-default");
      return;
    }

    document.querySelectorAll(`.filter--root ${in_stock_selector}`).forEach((input) => {
      input.checked = true;
    });

    // the theme rebuilds the url from the filter form only, keep utm/gclid/view params
    const extra_params = new URLSearchParams(location.search);
    [...new Set(extra_params.keys())].forEach((key) => {
      if (key === "page" || key === "sort_by" || key.startsWith("filter.")) extra_params.delete(key);
    });
    const extra_query = extra_params.toString();

    navigations.forEach((navigation) => {
      if (extra_query) navigation.url = `${navigation.getAttribute("data-url")}${extra_query}&`;
      navigation.clearRefineTags();
      navigation.renderActiveRefines();
      navigation.syncFilterGroupStates();
      navigation.toggleActiveTags();
    });

    navigations[0].showLoadingView();
    navigations[0].getAjaxUrl();
    wrapper.removeAttribute("data-stock-default");
  };

  customElements.whenDefined("navigation-element").then(applyStockDefault);
})();
